import { SectionHeader } from "~/common/components";
import { typedEntries } from "~/common/utils";
import { FunctionalDomainsV1 as FunctionalDomainsV1Type } from "~/providers/utils/types/patientIntakePreviewTypes";
import { FunctionalDomainCard } from "./FunctionalDomainCard";

interface FunctionalDomainsV1Props {
  functionalDomains: FunctionalDomainsV1Type;
}

export const FunctionalDomainsV1 = ({
  functionalDomains,
}: FunctionalDomainsV1Props) => {
  return (
    <div className="flex flex-col gap-4 border-b-1.5 border-b-neutral-700 pb-9">
      <SectionHeader>Functional domains</SectionHeader>

      {typedEntries(functionalDomains).map(([key, domain]) => (
        <FunctionalDomainCard key={key} value={key} domain={domain} />
      ))}
    </div>
  );
};
